import React from "react";
import withIconComponent from "../withIconComponent";

var Download = function Download() {
  return /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 16v6h20v-6",
    strokeLinecap: "square",
    "data-color": "color-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1v15",
    "data-cap": "butt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10l6 6 6-6",
    strokeLinecap: "square"
  }));
};

export default withIconComponent("UiDownload", false)(Download);